<template>
    <div>
        <table>
            <thead>
            <tr class="text-left">
                <th><md-checkbox v-model="globalCheck" @change="toggleAll"></md-checkbox></th>
                <th>Num</th>
                <th>Localisation</th>
                <th>Dispo. <br> ancien</th>
                <th>Type dispositif</th>
                <th>Contrôle</th>
                <th>Raison</th>
                <th>Nombre de capture</th>
                <th>Remplacement <br> GLU</th>
                <th>Com.</th>
                <th>Com. libre</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class=""><span>Oui</span> <span>Non</span></td>
                <td></td>
                <td></td>
                <td class="text-left"><span>Oui</span> <span>Non</span></td>
                <td></td>
                <td></td>
            </tr>
            <template v-if="config.comments.length > 0">
                <row2 v-for="(device, index) in devices" :key="device.id" :device="device" :index="index" :reasons="config.reasons" :comments="config.comments" :captures="config.captures" :device-types="deviceTypes"></row2>
            </template>
            </tbody>
        </table>
        <div class="md-layout">
            <div class="md-layout-item text-left">
                <md-button class="md-success md-sm md-button-action"
                           @click="submitReport()">
                    <span>Enregistrer</span>
                </md-button>
            </div>
            <div class="md-layout-item text-right">
                <md-button class="md-danger md-sm md-button-action text-right"
                           @click="deleteReport()">
                    <span>Supprimer</span>
                </md-button>
            </div>
        </div>
    </div>
</template>

<script>
import Row2 from "@/pages/Planning/Intervention/components/details/deviceReports/Rows/Row2";

export default {
    name: "TableReportModel2",
    components: {
        Row2
    },
    props: {
        deviceReport: {
            type: Array,
        }
    },
    data() {
        return {
            selected: [],
            deviceTypes: [],
            config: {
                captures: [
                    { value: 0 },
                    { value: 1 },
                    { value: 2 },
                    { value: 3 },
                    { value: 4 },
                    { value: 5 },
                    { value: 6 },
                    { value: 7 },
                    { value: 8 },
                    { value: 9 },
                    { value: 10 },
                ],
                reasons: [],
                comments: []
            },
            globalCheck: false,
            devices: this.deviceReport,
        }
    },
    methods: {
        async getDeviceReportInformation() {
            const {data} = await this.$store.dispatch('deviceReportTypes/getDeviceReportTypeForm', this.deviceReport[0].current_device_type.device_report_type_id)

            this.deviceTypes = data.deviceTypes
            this.config = {
                ...this.config,
                ...data.config
            }
        },
        toggleAll(e) {
            this.deviceReport.forEach((device) => {
                device.report_values.isChecked = e
            })
        },
        async submitReport() {
            let devices = []
            let canSave = false
            this.devices.forEach((device) => {
                if (device.report_values.isChecked) {
                    canSave = true
                    const isControlled = device.report_values.is_controlled

                    devices.push({
                        deviceId: device.id,
                        json: JSON.stringify({
                            isControlled: isControlled ? '1' : '0',
                            isGlueReplaced: isControlled ? (device.report_values.is_glue_replaced ? '1' : '0') : 'null',
                            comments: isControlled ? (device.report_values.comments.length > 0 ? device.report_values.comments.map(comment => comment.id.toString()).sort() : 'null') : 'null',
                            freeComment: device.report_values.free_comment,
                            reasonId: isControlled ? 'null' : device.report_values.reason.id.toString(),
                        }),
                        new_device_type_id: device.report_values.old_type ? device.report_values.type.id : null,
                        device_type_id: device.report_values.old_type?.id ?? device.report_values.type.id,
                        capture: isControlled ? parseInt(device.report_values.capture.value ?? 0) : null,
                    })
                    device.report_values.isChecked = false
                }
            })
            if (canSave) {
                this.$emit('submit-reports', devices)
            }
            this.globalCheck = false
        },
        async deleteReport() {
            let reports = []
            let canDelete = false

            this.devices.forEach((device) => {
                if (device.report_values.isChecked && device.report) {
                    canDelete = true
                    reports.push(device.report.id)
                }
                device.report_values.isChecked = false
            })
            if (canDelete) {
                this.$emit('delete-reports', reports)
            }
            this.globalCheck = false
        }
    },
    async mounted() {
        await this.getDeviceReportInformation()
    }
}
</script>

<style scoped>

</style>
